import React, { useState } from "react";
import classNames from "classnames";
import { AppCard } from "@/shared/Components";
import { ContactCardBody } from "./ContactCardBody";
import { ContactCardAvatar } from "./ContactCardImage";
import { ButtonCardClose } from "./ButtonCardClose";
import styles from "./styles.module.scss";

export type Contact = {
  id: string;
  title: string;
  name: string;
  phone: string;
  email: string;
  image: string;
};

interface Props {
  contact: Contact;
  className?: string;
  isClose?: boolean;
}

export const ContactCard: React.FC<Props> = ({ contact, isClose, className }) => {
  const [closeCard, setCloseCard] = useState(false);

  const handleClick = () => {
    setCloseCard((prev) => !prev);
  };

  return (
    <div className={styles.root}>
      <AppCard
        key={contact.id}
        className={classNames(
          styles["card-wrapper"],
          {
            [styles.close]: closeCard,
          },
          className,
        )}
      >
        <ContactCardAvatar src={contact.image} />
        <ContactCardBody
          title={contact.title}
          name={contact.name}
          phone={contact.phone}
          mail={contact.email}
        />
        {isClose && <ButtonCardClose closeCard={handleClick} />}
      </AppCard>
    </div>
  );
};
